import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

function resolve(mode) {
  if (mode === "auto") {
    const dark = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
    return dark ? "dark" : "light";
  }
  return mode;
}

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem("souq_theme") || "light");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", resolve(mode));
    localStorage.setItem("souq_theme", mode);
  }, [mode]);

  const toggle = () => setMode((m) => (resolve(m) === "light" ? "dark" : "light"));

  return <ThemeContext.Provider value={{ mode, setMode, toggle }}>{children}</ThemeContext.Provider>;
}
